var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 43.47" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-venue"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M48 13.18C46.94 6.24 36.55 0 24 0S.94 5.8 0 13.18v30.29h7v-11h7v11h5.8V31.28h8.35v12.19h5.94v-11H41v11h7zm-41.4 11a2.06 2.06 0 0 1-2.17-1.93v-4.82A2.06 2.06 0 0 1 6.6 15.5a2.06 2.06 0 0 1 2.17 1.93v4.78a2.06 2.06 0 0 1-2.17 1.93zm8.49-2.33a2.21 2.21 0 0 1-2.17-2.11v-6.42a2.06 2.06 0 0 1 2.17-1.93 2.06 2.06 0 0 1 2.17 1.93v6.38a2.21 2.21 0 0 1-2.17 2.11zm9.06-.62h-.35a2 2 0 0 1-2-2v-7.48a1.9 1.9 0 0 1 2-1.78h.35a1.9 1.9 0 0 1 2 1.78v7.48a2 2 0 0 1-2 1.96zm8.72.62a2.21 2.21 0 0 1-2.17-2.11v-6.42a2.06 2.06 0 0 1 2.17-1.93A2.06 2.06 0 0 1 35 13.32v6.38a2.21 2.21 0 0 1-2.13 2.11zm8.49 2.33a2.06 2.06 0 0 1-2.17-1.93v-4.82a2.06 2.06 0 0 1 2.17-1.93 2.06 2.06 0 0 1 2.17 1.93v4.78a2.06 2.06 0 0 1-2.18 1.93z", id: "Layer_1-2", "data-name": "Layer 1" })
    )
  );
});